const BaseService = require('@/services/BaseService')

const namespace = 'geo-reports'

const getSummary = (customerId, options, cb, errorCb) => {
    BaseService.get(`${namespace}/${customerId}/summary`, options, cb, errorCb)
}

const getSessionsOverTime = (customerId, options, cb, errorCb) => {
    BaseService.get(`${namespace}/${customerId}/sessions-over-time`, options, cb, errorCb)
}

const getAiChannels = (customerId, options, cb, errorCb) => {
    BaseService.get(`${namespace}/${customerId}/ai-channels`, options, cb, errorCb)
}

const getTopPages = (customerId, options, cb, errorCb) => {
    BaseService.get(`${namespace}/${customerId}/top-pages`, options, cb, errorCb)
}

const getYearlyBarCharts = (customerId, cb, errorCb) => {
    BaseService.get(`${namespace}/${customerId}/yearly-bar-charts`, {}, cb, errorCb)
}

export {
    getSummary,
    getSessionsOverTime,
    getAiChannels,
    getTopPages,
    getYearlyBarCharts,
}
